import { MeteoRowTitle } from './MeteoRowTitle.component';
import { ForecastParamCode, Forecasts } from 'pleinchamp-api-client';
import { useMemo } from 'react';
import {
  MeteoTemperatureChartLoader,
  MeteoTemperatureChartProps,
} from '@meteo/components/MeteoTemperatureChart/MeteoTemperatureChart.component';
import dynamic from 'next/dynamic';
import styles from '../MeteoWeatherTableContent.module.scss';

interface Props {
  onMouseEnter: (index: number) => void;
  is36h?: boolean;
  hoveredIndex?: number;
  metrics: Forecasts;
}

const MeteoTemperatureChart = dynamic<MeteoTemperatureChartProps>(
  () => import('../../../MeteoTemperatureChart/MeteoTemperatureChart.component').then((module) => module.MeteoTemperatureChart),
  { loading: () => <MeteoTemperatureChartLoader uniqueKey="tempChart" />, ssr: false }
);

function MeteoWeatherChart({ onMouseEnter, is36h, metrics, hoveredIndex }: Props) {
  const temperatureMetrics = useMemo(
    () => metrics.airTemperature && metrics.airTemperature.map((_data) => _data.value),
    [metrics]
  );

  function getResponsiveValue() {
    const breakpoints = [
      { maxWidth: 768, value: 65 },
      { maxWidth: 840, value: 67 },
      { maxWidth: 870, value: 68 },
      { maxWidth: 910, value: 70 },
      { maxWidth: 924, value: 72 },
      { maxWidth: 960, value: 74 },
      { maxWidth: 990, value: 76 },
      { maxWidth: 1000, value: 78 },
      { maxWidth: 1030, value: 80 },
      { maxWidth: 1055, value: 82 },
    ];

    const { value } = breakpoints.findLast((b) => window.innerWidth > b.maxWidth) || { value: 65 };
    return value;
  }

  return (
    <tr className={styles.chartRowTemperature}>
      <th>
        <MeteoRowTitle forecastParam={ForecastParamCode.airTemperature} is36h={is36h} />
      </th>
      <td className={`${styles.fifteenDays} ${styles.left}`} rowSpan={1} />
      {temperatureMetrics?.map((metric, i) => (
        <td
          key={metric.toString() + i.toString()}
          className={hoveredIndex === i ? styles.emphasis : ''}
          onMouseEnter={() => onMouseEnter(i)}
          rowSpan={1}
        >
          {i === 0 && (
            <MeteoTemperatureChart
              cellWidth={is36h ? getResponsiveValue() : 65}
              temperatures={temperatureMetrics as number[]}
            />
          )}
        </td>
      ))}
      <td className={`${styles.fifteenDays} ${styles.right}`} rowSpan={1} />
    </tr>
  );
}

export { MeteoWeatherChart };
